export default __webpack_public_path__ + "media/images/spinningwheel/sw-header-8de8686e939f735fb88b71c5a444d366.png";